import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';


@Injectable()
export class FavoritesService {

  constructor(private http: HttpClient) { }


    favorite(userId: number, listingId:number) {
      return this.http.post(`listing/${userId}/favorite/${listingId}`,{});
      
    }
    unfavorite(userId: number, listingId:number) {
      return this.http.delete(`listing/${userId}/favorite/${listingId}`);
      
    }
  }


